import { render, staticRenderFns } from "./consolidated-province.vue?vue&type=template&id=2b446c2c&scoped=true"
import script from "./consolidated-province.vue?vue&type=script&lang=js"
export * from "./consolidated-province.vue?vue&type=script&lang=js"
import style0 from "./consolidated-province.vue?vue&type=style&index=0&id=2b446c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b446c2c",
  null
  
)

export default component.exports